<template>
  <el-dialog
    class="us-pc-dialog btn-close"
    title="提示"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="onCancel"
  >
    <span>请使用电脑端访问</span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onCancel">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'us-pc-dialog',
  props: ['dialogVisible'],
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
<style lang="scss">
.us-pc-dialog {
  top: 20%;
  .el-dialog__header {
    text-align: left;
  }
  .el-dialog__body {
    font-size: 18px;
    text-align: center;
  }
  .el-button {
    background-color: #29bdb9;
    border: 0;
    border-radius: 2px;
    padding: 8px 18px;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/us-pc-dialog.vue